import { Routes } from '@angular/router';
import { AgreementsGuard, GUARDS, searchUri } from 'smartauction-frontend-micro-library';
import { AmbassadorGuard } from '../app/guards/ambassador/ambassador.guard';
import { AuthGuard, RoleBasedGuard } from 'remarketing-angular-library';


export const searchRoutes: Routes = [
  {
    path: 'search',
    children: [
      {
        path: 'results',
        loadComponent: () => import('./components/search-results-page/search.component').then(c => c.SearchResultsPage),
        canActivate: [
          AuthGuard,
          RoleBasedGuard,
          AgreementsGuard,
          AmbassadorGuard
        ],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ],
          roles: ['View_Only']
        }
      },
      {
        path: '',
        redirectTo: searchUri.SEARCH_URI,
        pathMatch: 'full'
      }
    ]
  }
];
